import template from './receipts.html';
import controller from './receipts.controller';

let receiptsComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default receiptsComponent;
